import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-secondary-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[35%] shrink-0">
            <p className="text-xs font-semibold uppercase tracking-widest text-secondary-600 mb-6">
              / About Us
            </p>
            <div className="flex items-center gap-3 mb-4">
              <div className="flex -space-x-2">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-secondary-300 border-2 border-secondary-50 overflow-hidden shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20fashion%20curator%20in%20warm%20neutral%20sweater%2C%20soft%20professional%20lighting%2C%20clean%20cream%20backdrop%2C%20friendly%20confident%20expression%2C%20modern%20headshot&width=120&height=120&seq=about-avatar-1-v3-sb&orientation=squarish"
                    alt="Superbuy spreadsheet research team member"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-secondary-300 border-2 border-secondary-50 overflow-hidden shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20woman%20in%20fashion%20industry%20with%20warm%20beige%20blazer%2C%20soft%20studio%20lighting%2C%20neutral%20cream%20background%2C%20friendly%20approachable%20smile%2C%20clean%20modern%20portrait&width=120&height=120&seq=about-avatar-2-v3-sb&orientation=squarish"
                    alt="Superbuy spreadsheet research team member"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-secondary-300 border-2 border-secondary-50 overflow-hidden shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20male%20ecommerce%20analyst%20in%20warm%20toned%20shirt%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20friendly%20confident%20demeanor%2C%20modern%20corporate%20portrait&width=120&height=120&seq=about-avatar-3-v3-sb&orientation=squarish"
                    alt="Superbuy spreadsheet research team member"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-secondary-300 border-2 border-secondary-50 overflow-hidden shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20young%20professional%20woman%20in%20ecommerce%2C%20warm%20neutral%20clothing%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20friendly%20genuine%20smile%2C%20clean%20modern%20headshot&width=120&height=120&seq=about-avatar-4-v3-sb&orientation=squarish"
                    alt="Superbuy spreadsheet research team member"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <span className="text-sm text-foreground-600 font-medium">
                + Our Research Team
              </span>
            </div>
            <p className="text-xs text-foreground-400">
              &bull; 5+ years in international shopping
            </p>
          </div>
          <div className="lg:w-[65%]">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-snug mb-6">
              Why We Built the{' '}
              <span className="text-primary-500 italic">Superbuy Spreadsheet</span>
              {' '}Collection
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                Shopping from international marketplaces can be overwhelming. With thousands of stores, millions of products, and countless shipping options, finding quality items at the right price takes serious time and effort. That&rsquo;s exactly why we created the Superbuy spreadsheet &mdash; a carefully curated collection of the best finds across every major category.
              </p>
              <p>
                Our team of experienced shoppers spends dozens of hours each week searching through stores, verifying seller ratings, checking product quality, and updating our spreadsheets. We test products ourselves, compare prices across multiple platforms, and only include items that meet our strict quality standards.
              </p>
              <p>
                Whether you&rsquo;re looking for the latest sneaker releases, premium hoodies, designer bags, or unique accessories, our Superbuy spreadsheet gives you direct access to verified product links. No more endless scrolling through forums or social media groups. Every link in our spreadsheet has been checked and verified for accuracy.
              </p>
              <p>
                We update our collection daily to ensure you always have access to the freshest finds. New products are added continuously, and dead links are removed within 24 hours. Our goal is simple: make international shopping faster, safer, and more enjoyable for everyone.
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4 md:gap-6 mt-8 pt-8 border-t border-secondary-200">
              {[
                { value: '14', label: 'Categories' },
                { value: '5K+', label: 'Products Listed' },
                { value: 'Daily', label: 'Updates' },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="font-heading text-2xl md:text-3xl font-bold text-primary-500">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <Link
                to="/superbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                Read our complete Superbuy spreadsheet guide
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}